import Button from '@mui/material/Button';
import { makeStyles } from 'utils/styles';
import Dialog from 'components/Dialog';
import RadioGroup from 'components/RadioGroup';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import theme from 'source/theme';

const useStyles = makeStyles({
  select1st: {
    color: theme.palette.secondary.main,
    fontWeight: 'bold'
  },
  select2nd: {
    color: theme.palette.secondary.main
    // fontSize: 10,
  }
});

const Component = props => {
  const {
    buttonText, currentOption, disabled=false, header, maxWidth, optionKey,
    options
  } = props;
  const { onSelection } = props;
  const classes = useStyles();

  const [open, setOpen] = useState(false);
  const [tempOptionId, setTempOptionId] = useState(currentOption && currentOption.id);

  useEffect(() =>
      setTempOptionId(currentOption && currentOption.id),
    [currentOption]
  );

  const handleClose = () => {
    setOpen(false);
    setTempOptionId(currentOption && currentOption.id);
  };

  const handleOpen = () => setOpen(true);

  const handleConfirm = () => {
    onSelection(tempOptionId);
    setOpen(false);
  };

  // The id comes back, not the text. It used to be the position of the label in
  // the list - `options[optionsList.indexOf(option)].id` - which is only correct
  // while the list is built in the same order as `options` and no two options
  // read the same. Neither is a property of the choice: sorting the list for
  // readability, or two flows sharing a name, would each pick the neighbour, and
  // would do it silently. So the value is the id and the label is only ever
  // shown.
  const handleOptionChange = optionId => setTempOptionId(Number(optionId));

  // `optionKey` is one field name or several to join - that part is unchanged,
  // it is what the reader sees.
  const labelOf = option => Array.isArray(optionKey)
    ? optionKey.map(oKey => option[oKey]).join(' ___ ')
    : option[optionKey];

  const optionsList = disabled ? [] : options.map(option => ({
    value: String(option.id),
    label: labelOf(option)
  }));
  const currentValue = tempOptionId == null ? '' : String(tempOptionId);

  return (
    <React.Fragment>
      <Button disabled={disabled} variant='outlined' size='small' color='secondary' onClick={handleOpen}>
        <span className={classes.select1st}>{buttonText} &nbsp;</span>
        {
          Array.isArray(optionKey) ?
            <span className={classes.select2nd}>{currentOption && optionKey.map(oKey => currentOption[oKey]).join(' - ')}</span> :
            <span className={classes.select2nd}>{currentOption && currentOption[optionKey]}</span>
        }
      </Button>
      {
        open &&
        <Dialog
          header={header}
          open={open}
          onClose={handleClose}
          onConfirm={handleConfirm}
          maxWidth={maxWidth}
        >
          {
            currentOption ?
              <RadioGroup
                onChange={handleOptionChange}
                options={optionsList}
                value={currentValue}
              /> :
              <span>
              Não existem opções ou nenhuma foi seleccionada.
            </span>
          }
        </Dialog>
      }

    </React.Fragment>
  );
};

export default Component;

Component.propTypes = {
  buttonText: PropTypes.string.isRequired,
  currentOption: PropTypes.object.isRequired,
  header: PropTypes.string.isRequired,
  maxWidth:  PropTypes.oneOf(['lg', 'md', 'sm', 'xl', 'xs', false]),
  optionKey: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]).isRequired,
  options: PropTypes.array.isRequired,
  onSelection: PropTypes.func.isRequired
};
